/* Basket top-ups (9 Oct 2026).
   Singapore baskets between S$40 and S$100 get up to three in-stock pieces under the free-delivery
   line, each priced so that one tap takes the basket to free delivery. Pieces Shopify rates as
   related to something in the basket come first ("You may like"); the rest are the best
   sellers in the price window ("Popular"). Since 13 Oct, a basket line's own pairings (the
   stacked.pairings metafield, "Goes well with") come before both; they arrive with the basket's
   server JSON (and the product page's, for the first add), so they need no request. Outside that range, or with nothing to
   suggest, the drawer's "People also loved" shows as before.
   - Server data: header-cart.liquid renders [data-sh-topups] (only for Singapore) and the basket
     lines as JSON in [data-sh-topups-cart]; templates/collection.sh-topups.liquid returns the
     price-window pool.
   - The drawer's inner part is replaced after every change (app.js refreshSideDrawerCartFromSection);
     a MutationObserver puts the top-ups back straight away from what is already fetched.
   - +/- taps update the total instantly through window.bulletApplyShippingFromCart, wrapped here. */
(function () {
  var FREE = 100;     // free delivery from S$100 in Singapore
  var MAX_GAP = 60;   // only suggest when the basket is within S$60 of it
  var SPAN = 30;      // suggested prices: from the gap to the gap + S$30
  var WIDE = 50;      // widened when that finds fewer than three
  var SHOW = 3;
  var POOL = '/collections/shop-all';
  var mem = {};
  var server = { items: [] };
  var page = null;          // the product page's own pairings: {p, pairs}
  var serverPairs = {};     // product id -> pairings, from the last basket render
  var lastTotal = null;
  var lastItems = null;
  var token = 0;

  function cacheGet(key) {
    if (mem[key]) return mem[key];
    try {
      var o = JSON.parse(sessionStorage.getItem('shTU:' + key) || 'null');
      if (o && Date.now() - o.t < 15 * 60 * 1000) return (mem[key] = o.d);
    } catch (e) {}
    return null;
  }
  function cacheSet(key, d) {
    mem[key] = d;
    try { sessionStorage.setItem('shTU:' + key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }

  function pool(lo, hi) {
    var key = 'pool:' + lo + '-' + hi;
    var c = cacheGet(key);
    if (c) return Promise.resolve(c);
    var url = POOL + '?view=sh-topups&filter.v.availability=1&filter.v.price.gte=' + lo +
      '&filter.v.price.lte=' + hi + '&sort_by=best-selling';
    return getJSON(url).then(function (d) { cacheSet(key, d); return d; }).catch(function () { return []; });
  }

  // Recommendation images come from cdn.shopify.com; the store serves the same files from its own
  // domain (/cdn/shop/files/...), which saves a connection to a second host on the phone.
  function sized(src) {
    if (!src) return '';
    src = src.replace(/^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/files\//, '/cdn/shop/files/');
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }
  function related(pid) {
    var key = 'rel:' + pid;
    var c = cacheGet(key);
    if (c) return Promise.resolve(c);
    return getJSON('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (d) {
        var list = ((d && d.products) || []).filter(function (p) {
          return p.available && p.variants && p.variants.length === 1 && p.variants[0].available && !p.gift_card;
        }).map(function (p) {
          return { v: p.variants[0].id, p: p.id, t: p.title, y: p.type, c: p.variants[0].price, u: p.url, i: sized(p.featured_image) };
        });
        cacheSet(key, list);
        return list;
      })
      .catch(function () { return []; });
  }

  function money(cents) {
    var v = cents / 100;
    return 'SGD ' + (v % 1 === 0 ? String(v) : v.toFixed(2));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function box() { return document.querySelector('section.cart--side-drawer .side-drawer-inner [data-sh-topups]'); }
  function readServer() {
    var el = document.querySelector('section.cart--side-drawer [data-sh-topups-cart]');
    if (!el) return;
    try { server = JSON.parse(el.textContent) || { items: [] }; } catch (e) {}
    (server.items || []).forEach(function (i) { if (i.pairs) serverPairs[i.p] = i.pairs; });
  }
  function readPage() {
    var el = document.querySelector('[data-sh-pairs-page]');
    if (!el) return;
    try { page = JSON.parse(el.textContent); } catch (e) {}
  }
  // A line's pairings: from the basket render, else remembered from an earlier one, else the page's.
  function pairsOf(i) {
    if (i.pairs) return i.pairs;
    if (serverPairs[i.p]) return serverPairs[i.p];
    return page && String(page.p) === String(i.p) ? page.pairs : [];
  }
  function pairsIn(items) {
    var out = [];
    (items || []).forEach(function (i) { if (!i.gc) out = out.concat(pairsOf(i)); });
    return out;
  }
  function totalFrom(items) {
    return (items || []).filter(function (i) {
      return !i.gc && !/gift card/i.test(i.title || i.t || '');
    }).reduce(function (s, i) { return s + (i.line != null ? i.line : (i.line_price || 0)); }, 0) / 100;
  }

  // Cards already on screen are kept and moved into each new drawer instead of being drawn again,
  // so their photos don't blink when the drawer is redrawn after a basket change.
  var kept = { key: '', nodes: null };

  // Measurement: one dataLayer event per new set of suggestions shown (sh_topup_shown), per tap on a
  // suggestion's photo or name (sh_topup_click) and per + Add (sh_topup_add). The add also stamps the
  // basket line with the hidden property _topup (the group label), so orders carry it: filter orders'
  // line items on _topup to measure revenue and free-delivery conversions without any analytics tool.
  var lastShown = '';
  function track(name, data, dedupe) {
    try {
      if (dedupe) { if (dedupe === lastShown) return; lastShown = dedupe; }
      window.dataLayer = window.dataLayer || [];
      data.event = name;
      window.dataLayer.push(data);
    } catch (e) {}
  }

  function pickKey(picks) { return picks.map(function (x) { return x.v + ':' + x.why; }).join(','); }
  function hide(el, pal) {
    if (el) { el.hidden = true; el.innerHTML = ''; }
    if (pal) pal.style.display = '';
  }
  function show(el, pal, picks) {
    var key = pickKey(picks);
    if (kept.key === key && kept.nodes) {
      if (el.firstChild !== kept.nodes[0]) {
        el.innerHTML = '';
        kept.nodes.forEach(function (n) { el.appendChild(n); });
      }
    } else {
      el.innerHTML = render(picks);
      kept = { key: key, nodes: Array.prototype.slice.call(el.childNodes) };
      track('sh_topup_shown', { sh_topup_basket: lastTotal, sh_topup_count: picks.length, sh_topup_groups: picks.map(function (x) { return x.why; }).join(',') }, key);
    }
    el.hidden = false;
    if (pal) pal.style.display = 'none';
  }

  function render(picks) {
    var cards = picks.map(function (x) {
      return '<div class="sh-tu__c">' +
        '<a class="sh-tu__im" href="' + esc(x.u) + '"><img src="' + esc(x.i) + '" alt="' + esc(x.t) + '" decoding="async"></a>' +
        '<div class="sh-tu__b">' +
          '<span class="sh-tu__tag">' + esc(x.why) + '</span>' +
          '<a class="sh-tu__t" href="' + esc(x.u) + '">' + esc(x.t) + '</a>' +
          '<div class="sh-tu__p"><b>' + money(x.c) + '</b>' +
          '<button type="button" class="sh-tu__add" data-sh-tu-add="' + x.v + '" data-sh-tu-p="' + x.p + '" data-sh-tu-c="' + x.c + '" data-sh-tu-why="' + esc(x.why) + '" aria-label="Add ' + esc(x.t) + '">+ Add</button></div>' +
        '</div></div>';
    }).join('');
    return '<p class="sh-tu__h">Top up to free delivery</p><div class="sh-tu__g">' + cards + '</div>';
  }

  // Choose up to three: the basket's own pairings first, then Shopify's related, then best sellers.
  function choose(gap, rel, poolItems, widened, items) {
    var inCart = {};
    (items || []).forEach(function (i) { inCart[i.p] = true; });
    var lo = Math.ceil(gap * 100), seen = {}, out = [];
    function add(x, why, hiCents) {
      if (out.length >= SHOW || seen[x.p] || inCart[x.p] || x.c < lo || x.c > hiCents) return;
      seen[x.p] = true;
      out.push({ v: x.v, p: x.p, t: x.t, c: x.c, u: x.u, i: x.i, why: why });
    }
    // Shopify's "related" picks are similar or bought-together pieces, not curated pairings, so the
    // label stays modest. Everything is priced from the gap to the gap + S$30 (+ S$50 for the
    // best sellers only when that finds fewer than three).
    // Pairings are chosen for the product, so they may run to the gap + S$50 before anything else.
    var pairs = pairsIn(items);
    pairs.forEach(function (x) { add(x, 'Pairs well', lo + SPAN * 100); });
    pairs.forEach(function (x) { add(x, 'Pairs well', lo + WIDE * 100); });
    rel.forEach(function (r) { r.list.forEach(function (x) { add(x, 'You may like', lo + SPAN * 100); }); });
    poolItems.forEach(function (x) { add(x, 'Popular', lo + SPAN * 100); });
    if (out.length < SHOW && widened) poolItems.forEach(function (x) { add(x, 'Popular', lo + WIDE * 100); });
    return out;
  }

  // Everything already fetched: choose straight away, in the same frame as the drawer redraw.
  function chooseFromCache(gap, lo, sources, items) {
    var own = choose(gap, [], [], false, items);   // pairings alone need nothing fetched
    if (own.length >= SHOW) return own;
    var rel = [];
    for (var k = 0; k < sources.length; k++) {
      var l = cacheGet('rel:' + sources[k].p);
      if (!l) return null;
      rel.push({ list: l });
    }
    var p1 = cacheGet('pool:' + lo + '-' + (lo + SPAN));
    if (!p1) return null;
    var picks = choose(gap, rel, p1, false, items);
    if (picks.length >= SHOW) return picks;
    var p2 = cacheGet('pool:' + lo + '-' + (lo + WIDE));
    return p2 ? choose(gap, rel, p1.concat(p2), true, items) : null;
  }

  var pending = false;
  function drawerOpen() { return document.body.classList.contains('open-cart'); }

  function outline(el, pal) {
    if (el.querySelector('.sh-tu__c')) return;   // cards or outline already showing: keep them
    el.innerHTML = '<p class="sh-tu__h">Top up to free delivery</p><div class="sh-tu__g">' +
      new Array(SHOW + 1).join('<div class="sh-tu__c sh-tu__c--wait"><span class="sh-tu__im"></span><span class="sh-tu__b"></span></div>') +
      '</div>';
    el.hidden = false;
    if (pal) pal.style.display = 'none';
  }

  // opts.early: Shopify confirmed an add but the drawer hasn't been redrawn yet (the bar still shows
  // the old amount): if the basket has left the S$40-100 band, change nothing and let the redraw
  // swap it, so the shopper sees one change, not two. opts.noPal: hide the top-ups without
  // bringing back the old "People also loved" (the redraw brings the right one).
  function update(total, items, partial, opts) {
    opts = opts || {};
    items = items || server.items || [];
    var el = box();
    if (!el) return;
    var pal = el.parentNode && el.parentNode.querySelector('.pal-box-wrapper');
    lastTotal = total;
    lastItems = items;
    var gap = Math.round((FREE - total) * 100) / 100;
    if (!(total > 0) || gap <= 0 || gap > MAX_GAP) {
      if (opts.early) return;
      pending = false; token++;
      hide(el, opts.noPal ? null : pal);
      return;
    }
    var lo = Math.ceil(gap);
    // A line just added but not yet confirmed (we don't know which product it is): don't choose yet,
    // or the suggestions would change again a moment later. Hold what's there, or the outline.
    if (partial) { outline(el, pal); return; }
    var sources = items.filter(function (i) { return !i.gc; }).slice(0, 2);
    var mine = ++token;
    var cached = chooseFromCache(gap, lo, sources, items);
    if (cached) {
      pending = false;
      if (cached.length) show(el, pal, cached); else hide(el, pal);
      return;
    }
    // Nothing is fetched while the basket is closed: page loads cost no extra requests or images.
    // Opening the basket (an add opens it as the request is sent) starts the lookup; after that it is
    // remembered for 15 minutes. Meanwhile the server's placeholder cards hold the space.
    if (!drawerOpen()) { pending = true; return; }
    pending = false;
    Promise.all([
      Promise.all(sources.map(function (i) {
        return related(i.p).then(function (list) { return { list: list }; });
      })),
      pool(lo, lo + SPAN)
    ]).then(function (res) {
      var picks = choose(gap, res[0], res[1], false, items);
      if (picks.length >= SHOW) return picks;
      return pool(lo, lo + WIDE).then(function (wide) { return choose(gap, res[0], res[1].concat(wide), true, items); });
    }).then(function (picks) {
      if (mine !== token) return;            // a newer basket total is being handled
      var cur = box();
      if (!cur) return;
      var curPal = cur.parentNode && cur.parentNode.querySelector('.pal-box-wrapper');
      if (!picks.length) { hide(cur, curPal); return; }
      show(cur, curPal, picks);
    });
  }

  function fromServer() { readServer(); update(totalFrom(server.items)); }

  // + Add: through CartJS like every other add, so the drawer redraws and the bar moves as usual.
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-sh-tu-add]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-sh-tu-add'), 10);
    btn.disabled = true;
    btn.textContent = 'Adding';
    var done = function () { btn.disabled = false; btn.textContent = '+ Add'; };
    var why = btn.getAttribute('data-sh-tu-why') || 'top-up';
    track('sh_topup_add', { sh_topup_variant: id, sh_topup_group: why, sh_topup_price: (parseInt(btn.getAttribute('data-sh-tu-c'), 10) || 0) / 100, sh_topup_basket: lastTotal });
    if (window.CartJS && typeof CartJS.addItem === 'function') {
      CartJS.addItem(id, 1, { _topup: why }, { success: done, error: done });
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1, properties: { _topup: why } }) })
        .then(function () { if (typeof refreshSideDrawerCartFromSection === 'function') refreshSideDrawerCartFromSection(true); })
        .finally(done);
    }
  });

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('.sh-tu__im, .sh-tu__t');
    if (!a) return;
    var tag = a.closest('.sh-tu__c') && a.closest('.sh-tu__c').querySelector('.sh-tu__tag');
    track('sh_topup_click', { sh_topup_group: tag ? tag.textContent : '', sh_topup_url: a.getAttribute('href'), sh_topup_basket: lastTotal });
  });

  // Start fetching the moment Add to basket is tapped: the product page knows the product and its
  // price, so the suggestions are ready by the time Shopify confirms the add and the drawer redraws.
  function prefetchForAdd(settings) {
    try {
      var data = settings && settings.data, id = null, qty = 1;
      if (typeof data === 'string') {
        var q = new URLSearchParams(data);
        id = q.get('id') || q.get('items[0][id]');
        qty = parseInt(q.get('quantity') || q.get('items[0][quantity]') || '1', 10) || 1;
      } else if (data && typeof data === 'object') {
        id = data.id || (data.items && data.items[0] && data.items[0].id);
        qty = parseInt(data.quantity || (data.items && data.items[0] && data.items[0].quantity) || 1, 10) || 1;
      }
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (!id || !meta || !meta.variants) return;
      var v = meta.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      var est = totalFrom(server.items) + (v.price * qty) / 100;
      var gap = Math.round((FREE - est) * 100) / 100;
      if (gap <= 0 || gap > MAX_GAP) return;
      var lo = Math.ceil(gap);
      // The basket as it will be once Shopify confirms: choose now (instantly when already fetched);
      // the confirmed basket gives the same lines, so the cards stay put.
      var est = [{ k: null, p: meta.id, y: meta.type, line: v.price * qty, gc: false }].concat(server.items || []); // Shopify lists the newest line first
      update(totalFrom(est), est);
      pool(lo, lo + SPAN).then(function (d) { if (d.length < SHOW + 2) pool(lo, lo + WIDE); });
    } catch (e) {}
  }

  // Shopify's answer to an add lists the line it added: with the lines already in the basket, that
  // is the whole basket, about half a second before the drawer is redrawn.
  function confirmAdd(xhr) {
    try {
      var r = xhr.responseJSON || JSON.parse(xhr.responseText || 'null');
      var added = r && (r.items || [r]);
      if (!added || !added[0] || !added[0].product_id) return;
      var byKey = {};
      var merged = (server.items || []).map(function (i) { byKey[i.k] = true; return i; });
      added.forEach(function (i) {
        var line = { k: i.key, p: i.product_id, y: i.product_type, line: i.final_line_price != null ? i.final_line_price : i.line_price, gc: !!i.gift_card, title: i.title };
        if (byKey[i.key]) merged = merged.map(function (m) { return m.k === i.key ? line : m; });
        else merged.unshift(line);
      });
      update(totalFrom(merged), merged, false, { early: true });
    } catch (e) {}
  }

  function start() {
    readPage();
    if (window.jQuery) {
      jQuery(document).ajaxSend(function (ev, xhr, settings) {
        if (/\/cart\/add\.js/.test((settings && settings.url) || '')) prefetchForAdd(settings);
      });
      jQuery(document).ajaxSuccess(function (ev, xhr, settings) {
        if (/\/cart\/add\.js/.test((settings && settings.url) || '')) confirmAdd(xhr);
      });
    }
    var inner = document.querySelector('section.cart--side-drawer .side-drawer-inner');
    if (inner && window.MutationObserver) {
      // The drawer's inside is replaced after every basket change: put the top-ups back.
      new MutationObserver(fromServer).observe(inner, { childList: true });
    }
    // Instant +/- updates pass the lines as they stand on screen.
    var orig = window.bulletApplyShippingFromCart;
    if (typeof orig === 'function' && !orig.shTopups) {
      var wrapped = function (cart) {
        orig.apply(this, arguments);
        if (!cart || !cart.items) return;
        var live;
        if (cart.items.length && cart.items[0].product_id) {
          // Shopify's own basket (after an add): the same lines the redrawn drawer will have, so the
          // suggestions chosen now are the ones that stay.
          live = cart.items.map(function (i) {
            return { k: i.key, p: i.product_id, y: i.product_type, line: i.final_line_price != null ? i.final_line_price : i.line_price, gc: !!i.gift_card, title: i.title };
          });
          update(totalFrom(live), live, false, { noPal: true });
          return;
        }
        // Instant +/- (lines as they stand on screen; a removed one is folding away): base the
        // suggestions on the lines still there.
        var keys = Array.prototype.map.call(
          document.querySelectorAll('section.cart--side-drawer .side-drawer-inner .productsInCart[data-sh-key]:not(.sh-removing)'),
          function (r) { return r.getAttribute('data-sh-key'); });
        live = (server.items || []).filter(function (i) { return keys.indexOf(i.k) !== -1; });
        var unconfirmed = document.querySelector('section.cart--side-drawer .side-drawer-inner .productsInCart:not([data-sh-key]):not(.sh-removing)');
        update(totalFrom(cart.items), live, !!unconfirmed);
      };
      wrapped.shTopups = true;
      window.bulletApplyShippingFromCart = wrapped;
    }
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (pending && drawerOpen()) update(lastTotal, lastItems);
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    fromServer();
  }
  // header-cart.liquid sets bulletApplyShippingFromCart on DOMContentLoaded; wrap it after that.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 0); });
  } else {
    setTimeout(start, 0);
  }
})();
